import { render } from "./shoppingListApp.vue?vue&type=template&id=69645454"
import script from "./shoppingListApp.vue?vue&type=script&lang=js"
export * from "./shoppingListApp.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__